import { type AltoIconName, type ColorVariant } from '@alto/design-library-tokens';
import React from 'react';
import { FuzeRxIcon } from './FuzeRxIcon.web';

type IconProps = {
  readonly name: AltoIconName;
  readonly accessibilityLabel?: string;
  readonly allowFontScaling?: boolean;
  readonly type?: ColorVariant;
  readonly testID?: string;
};

/**
 * Renders the brand icon set. Post-rebrand there is a single brand (FuzeRx), which renders
 * Material Symbols; `Icon.native.tsx` is the native counterpart so the web renderer's `<span>`
 * never reaches the native bundle.
 */
export const Icon = ({ name, accessibilityLabel, type, allowFontScaling = true, testID }: IconProps) => {
  return (
    <FuzeRxIcon
      name={name}
      accessibilityLabel={accessibilityLabel}
      type={type}
      allowFontScaling={allowFontScaling}
      testID={testID}
    />
  );
};
